export default __webpack_public_path__ + "static/grid-2-887a20616f09a268656f5a91a718f6ef.svg";